import { AxiosError } from 'axios'
import { computed, flow, makeObservable, toJS } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils'

import { UrlParams } from 'Portals/Customer/constants'
import { ServiceLocation } from 'Portals/Customer/entities'
import { getFiltersConfig } from 'Portals/Customer/Pages/ServiceLocation/TableList/Filters/utils/config'
import { ServiceLocationRepo } from 'Portals/Customer/repositories'

import { RootStore } from '../rootStore/RootStore'

const STORAGE_SERVICE_LOCATION_PAGE_SIZE = storagePageSizeConstant('serviceLocationTable')

export class ServiceLocationTable extends TableStore<ServiceLocation.Basic> {
	constructor(private rootStore: RootStore) {
		super(STORAGE_SERVICE_LOCATION_PAGE_SIZE)
	}

	@computed
	get serviceLocationData() {
		return toJS(this.items)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				defaultSort,
				repository: ServiceLocationRepo.getList
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}
	initFromURLParams = (params: Record<string, string[]>) => {
		const filterKeys = [
			UrlParams.serviceLocationId,
			UrlParams.billingLocationId,
			UrlParams.programManagerId
		]

		this.initFilterParamsFromUrl(params, filterKeys, getFiltersConfig())
	}
}
